import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { LoginOutlined } from "@mui/icons-material";
import { CustomBtn } from "../../components/Common/CustomBtn";

const Splash = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const mediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        m: 0,
        background: theme.palette.background.gradient,
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
      }}
    >
      <img
        src={require("../../assets/images/logo_lg.png")}
        alt="logo"
        style={{
          height: mediumScreen ? "300px" : "500px",
          width: mediumScreen ? "300px" : "500px",
        }}
      />

      <Box
        sx={{
          width: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <CustomBtn
          text="Login"
          Icon={LoginOutlined}
          width={mediumScreen ? "100%" : "50%"}
          onClick={() => navigate("/login")}
        />
      </Box>
    </Box>
  );
};

export default Splash;
